// extracted by mini-css-extract-plugin
module.exports = {"articlesList":"articles-list_articlesList__5LC9m","articlesListExpanded":"articles-list_articlesListExpanded__glUsd","articlesListItem":"articles-list_articlesListItem__dohlT"};